import { defineSlotRecipe } from '@chakra-ui/react';

export const navigationSlotRecipe = defineSlotRecipe({
    slots: ['button', 'navGroupTitle'],
    base: {
        button: {
            mr: '2',
            fontWeight: 'semibold',
            color: 'secondary.600',
        },
        navGroupTitle: {
            textTransform: 'uppercase',
            fontWeight: 'bold',
            pointerEvents: 'none',
            fontSize: 'md',
            color: 'gray.500',
        },
    },
});
